export class Payment {
  constructor(
    private _paymentId: string = null,
    private _status: string = null,
    private _amount: number = null,
    private _amountInCent: number = null,
    private _currency: string = null,
    private _orderItems: any[] = [],
    private _length: number = null,
    private _categoryId: string = null,
    private _createdDatetime: string = null,
    private _createdTimestamp: Date = null,
    private _deletedTimestamp: Date = null,
    private _finalizedTimestamp: Date = null,
    private _paymentInProgressTimestamp: Date = null,
    private _rejectedTimestamp: Date = null
  ) {
  }

  get paymentId(): string {
    return this._paymentId;
  }

  get status(): string {
    return this._status;
  }

  get amount(): number {
    return this._amount;
  }

  get amountInCent(): number {
    return this._amountInCent;
  }

  get currency(): string {
    return this._currency;
  }

  get orderItems(): any[] {
    return this._orderItems;
  }

  get length(): Number {
    return this._length;
  }

  get categoryId(): string {
    return this._categoryId;
  }

  get createdDatetime(): string {
    return this._createdDatetime;
  }

  get createdTimestamp(): Date {
    return this._createdTimestamp;
  }

  get deletedTimestamp(): Date {
    return this._deletedTimestamp;
  }

  get finalizedTimestamp(): Date {
    return this._finalizedTimestamp;
  }

  get paymentInProgressTimestamp(): Date {
    return this._paymentInProgressTimestamp;
  }

  get rejectedTimestamp(): Date {
    return this._rejectedTimestamp;
  }

  static fromPos(paymentResponse): Payment {
    return new Payment(
      paymentResponse.orderId,
      paymentResponse.status,
      paymentResponse.amount,
      paymentResponse.amountInCent,
      paymentResponse.currency,
      paymentResponse.orderItems,
      paymentResponse.length,
      paymentResponse.categoryId,
      paymentResponse.createdDatetime,
      paymentResponse.createdTimestamp,
      paymentResponse.deletedTimestamp,
      paymentResponse.finalizedTimestamp,
      paymentResponse.paymentInProgressTimestamp,
      paymentResponse.rejectedTimestamp
    )
  }

  static fromRaw(paymentRaw): Payment {
    return new Payment(
      paymentRaw.key,
      paymentRaw.data.status,
      paymentRaw.data.amount,
      paymentRaw.data.amountInCent,
      paymentRaw.data.currency,
      paymentRaw.data.orderItems,
      paymentRaw.data.length,
      paymentRaw.data.categoryId,
      paymentRaw.data.createdDatetime,
      paymentRaw.data.createdTimestamp,
      paymentRaw.data.deletedTimestamp,
      paymentRaw.data.finalizedTimestamp,
      paymentRaw.data.paymentInProgressTimestamp,
      paymentRaw.data.rejectedTimestamp
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/payment.ts